export const SHOW_DIALOGUE = "SHOW_DIALOGUE";
export const HIDE_DIALOGUE = "HIDE_DIALOGUE";
export const SHOW_DIALOGUE_PLAYLIST = "SHOW_DIALOGUE_PLAYLIST";
